var React = require('react');

function Microsoft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"}));
}

Microsoft.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Microsoft;

Microsoft.default = Microsoft;
